import { useDispatch } from 'react-redux'

import { appActions } from 'store/app'

export function useSnackbar() {
  const dispatch = useDispatch()
  const setSnackbarState = (payload) => dispatch(appActions.snackbar(payload))

  const snackbarDefaultProps = {
    open: true,
    message: '',
    variant: 'alert',
    alert: { variant: 'standard' },
    anchorOrigin: { vertical: 'top', horizontal: 'center' },
    transition: 'SlideLeft',
    showBackDrop: false,
    close: true
  }

  function setSnackbar(props) {
    props = { ...snackbarDefaultProps, ...props }
    const { open, message, variant, alert, anchorOrigin, transition, navLink, showBackDrop, close } = props

    const payload = {
      open: open,
      message: message,
      variant: variant,
      alert: alert,
      close: close,
      anchorOrigin: anchorOrigin,
      transition: transition,
      showBackDrop: showBackDrop,
      navLink: navLink
    }

    setSnackbarState(payload)
  }

  return { setSnackbar }
}
